import { render } from "./TabNav.vue?vue&type=template&id=e08d3a4e"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__